// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qg8h","name":"Header_name__3Zxl9","birthday":"Header_birthday__2Jm1k","skeleton":"Header_skeleton__1npDL"};